import {ChildEntity} from "typeorm";
import {ShallowRef} from "vue";
import {Component} from "@vue/runtime-core";
import {Player} from "@/modules/team/entity/Player";
import PlayerContractTerminatedNotificationComponent
  from "@/modules/team/components/PlayerContractTerminatedNotification.vue";
import {Notification} from "@/modules/notifications/entity";

@ChildEntity()
export class PlayerContractTerminatedNotification extends Notification {
  setPayload(player: Player, price: number) {
    this.payloadRaw = JSON.stringify({playerId: player.id, playerName: player.shortName, price});

    return this;
  }

  get payload(): { playerId: number, playerName: string, price: number } {
    return JSON.parse(this.payloadRaw!);
  }

  get component(): ShallowRef<Component> {
    return shallowRef(PlayerContractTerminatedNotificationComponent);
  }
}